module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY13.547b1081.jpg";